import React, { useState } from "react";
import { Coins, Heart, Sprout, Lock } from "lucide-react";
import PaywallModal from "./PaywallModal";
import { useTopCities } from "./topcities/useTopCities";
import { CategoryCard } from "./topcities/CategoryCard";
import { NeedsNatalCard } from "./topcities/NeedsNatalCard";
import { CityDetail } from "./topcities/CityDetail";

const CATEGORIES = [
  { key: "money", label: "Top Money City", icon: Coins, color: "#C8A96E", sources: "Jupiter · Sun · MC lines" },
  { key: "love", label: "Top Love City", icon: Heart, color: "#C9744F", sources: "Venus · Moon · DC lines" },
  { key: "healing", label: "Top Healing City", icon: Sprout, color: "#14B8A6", sources: "Chiron · Moon · IC lines" },
];

export default function TopCitiesRow({ variant = "row" }) {
  const { data, loading, needsNatal } = useTopCities();
  const [active, setActive] = useState(null);
  const [paywall, setPaywall] = useState(false);

  if (needsNatal) return <NeedsNatalCard />;

  const locked = !!data?.locked;
  const activeCat = active ? CATEGORIES.find((c) => c.key === active) : null;
  const activeCity = active && data && !locked ? data[active] : null;
  const pick = (key) => {
    if (locked) { setPaywall(true); return; }
    setActive((cur) => (cur === key ? null : key));
  };

  return (
    <>
      <section className="rounded-2xl border border-[#C8A96E]/30 bg-gradient-to-br from-[#1C1622] to-[#261E2E] p-4 sm:p-5" data-testid="top-cities-row">
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="text-[9px] uppercase tracking-[0.3em] text-[#C8A96E]">Yearly & Lifetime · Subscriber Insights</div>
            <div className="font-heading text-lg sm:text-xl mt-0.5">Your three destined cities</div>
          </div>
          {locked && (
            <span className="text-[9px] uppercase tracking-widest text-[#C8A96E] border border-[#C8A96E]/50 rounded-full px-2 py-1 flex items-center gap-1">
              <Lock size={11} /> Locked
            </span>
          )}
        </div>
        <div className={`grid ${variant === "row" ? "sm:grid-cols-3" : "grid-cols-1"} gap-3`}>
          {CATEGORIES.map((c) => (
            <CategoryCard key={c.key} c={c} city={!locked && data ? data[c.key] : null} isActive={active === c.key} loading={loading} locked={locked} onClick={() => pick(c.key)} />
          ))}
        </div>
        {!locked && activeCity && activeCat && <CityDetail activeCat={activeCat} activeCity={activeCity} />}
      </section>
      <PaywallModal open={paywall} onClose={() => setPaywall(false)} context="destined_cities" />
    </>
  );
}
